export default __webpack_public_path__ + "static/media/linux_system_metrics.e20952ec.md";